import React from 'react';
import { tm } from '@/utils/tm';
import { Color } from '@diritto/common/style/color';
import { shortenCount } from '@diritto/common/utils/string';
import { FavoriteEmptyIcon } from 'icons/FavoriteIcon';
import { NotiIcon } from 'icons/NotiIcon';
import { RecommendBorderIcon } from 'icons/RecommendIcon';
import { ReplyBlankIcon } from 'icons/ReplyBlankIcon';
import { VisibilityIcon } from 'icons/VisibilityIcon';

export enum IconCountType {
  Favorite = 'Favorite',
  Reply = 'Reply',
  View = 'View',
  Recommend = 'Recommend',
  NewEpisodeNoti = 'NewEpisodeNoti',
}

interface IconCountProps {
  className?: string;
  type: IconCountType;
  count: number;
  color?: string;
  iconClassName?: string;
  textClassName?: string;
}

const getIcon = (type: IconCountType, color: string, iconClassName?: string) =>
  ({
    [IconCountType.Favorite]: <FavoriteEmptyIcon color={color} className={iconClassName} />,
    [IconCountType.Reply]: <ReplyBlankIcon color={color} className={iconClassName} />,
    [IconCountType.View]: <VisibilityIcon color={color} className={iconClassName} />,
    [IconCountType.Recommend]: <RecommendBorderIcon color={color} className={iconClassName} />,
    [IconCountType.NewEpisodeNoti]: <NotiIcon fill={false} color={color} fillColor={color} className={iconClassName} />,
  })[type];

export const IconCount = ({
  className,
  type,
  count,
  color = Color.Gray400,
  iconClassName = 'size-[16px]',
  textClassName,
}: IconCountProps) => (
  <div className={tm('flex justify-center items-center', className ?? '')}>
    {getIcon(type, color, iconClassName)}
    <p className={tm('ml-1 text-gray-500 text-xxxs', textClassName ?? '')}>{shortenCount(count)}</p>
  </div>
);
